import { render, staticRenderFns } from "./patientAlertReport.vue?vue&type=template&id=6b84ef1f"
import script from "./patientAlertReport.vue?vue&type=script&lang=js"
export * from "./patientAlertReport.vue?vue&type=script&lang=js"
import style0 from "./patientAlertReport.vue?vue&type=style&index=0&id=6b84ef1f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports